<section class="relative w-full overflow-hidden text-white py-16">
  <!-- Hintergrundbild -->
  <div class="absolute inset-0 -z-10">
    @if (tile?.backgroundImage?.fields?.file?.url; as bgUrl) {
    <img
      [src]="bgUrl.startsWith('//') ? 'https:' + bgUrl : bgUrl"
      class="tile-background-image w-full h-full object-cover"
      alt=""
    />
    }
    <div class="absolute inset-0 bg-black/35 md:bg-transparent"></div>
  </div>

  <div class="relative text-center max-w-6xl mx-auto px-6">
    @switch (tile?.type) { @case ('Type2') {
    <!-- ===================== -->
    <!-- TYPE 2 (ANY QUESTIONS) -->
    <!-- ===================== -->
    <div
      class="max-w-3xl"
      [ngClass]="{
        'text-center md:text-left ml-0 mr-auto': tile?.textAlignment === 'left',
        'text-center md:text-right ml-auto mr-0': tile?.textAlignment === 'right',
        'text-center md:text-center mx-auto': tile?.textAlignment === 'center'
      }"
    >
      <h1 class="tile-heading text-3xl text-black font-primary italic tracking-wide">
        {{ tile?.title }}
      </h1>

      <div
        class="tile-copy type2 mt-6 text-base text-black sm:text-lg md:text-xl font-primary leading-relaxed"
        [innerHTML]="documentToHtmlString(tile?.text)"
      ></div>

      @if (tile?.email) {
      <div class="mt-6 text-base sm:text-lg md:text-xl font-primary">
        <a
          class="underline underline-offset-4 hover:opacity-90 transition"
          [href]="'mailto:' + tile.email"
        >
          mailto:{{ tile.email }}
        </a>
      </div>
      }

      <div class="mt-8">
        @if (tile?.button?.fields) {
        <jnguyen-button [button]="tile.button.fields"></jnguyen-button>
        }
      </div>
    </div>
    } @default {
    <!-- ===================== -->
    <!-- TYPE 1 (bestehend)    -->
    <!-- ===================== -->
    <div
      [ngClass]="{
        'text-center md:text-left ml-0 mr-auto': tile?.textAlignment === 'left',
        'text-center md:text-right  mr-0': tile?.textAlignment === 'right',
        'text-center md:text-center mx-auto': tile?.textAlignment === 'center'
      }"
    >
      <h1 class="tile-heading text-3xl font-primary font-bold tracking-[0.08em] uppercase">
        {{ tile?.title }}
      </h1>

      <h2 class="tile-subheading mt-4 text-white text-lg font-primary font-bold uppercase">
        {{ tile?.subtitle }}
      </h2>
    </div>

    <div
      class="tile-copy mt-8 text-white md:max-w-2xl text-base sm:text-lg md:text-xl font-primary leading-relaxed whitespace-pre-line"
      [ngClass]="{
        'text-center md:text-left ml-0 mr-auto': tile?.textAlignment === 'left',
        'text-center md:text-right ml-auto mr-0': tile?.textAlignment === 'right',
        'text-center md:text-center mx-auto': tile?.textAlignment === 'center'
      }"
      [innerHTML]="documentToHtmlString(tile?.text)"
    ></div>
    } }
  </div>
</section>
